import React from "react"
import { FormControlLabel, Switch as MuiSwitch } from "@material-ui/core"

const Switch = ({ label, color, ...rest }) => {
  return <FormControlLabel control={<MuiSwitch color={color || "primary"} {...rest} />} label={label} />
}

export { Switch }
